import createLucideIcon from '../createLucideIcon';

const ArrowUpRight = createLucideIcon('ArrowUpRight', [
  ['line', { x1: '7', x2: '17', y1: '17', y2: '7', key: '11kluq' }],
  ['polyline', { points: '7 7 17 7 17 17', key: 'blehsp' }],
]);

export default ArrowUpRight;
